module.exports = __webpack_public_path__ + "static/media/belfius.b07feea4.png";